/* eslint-disable no-prototype-builtins */
import { LocalDate, nativeJs } from 'js-joda';

export const dateFormats = {
  'en-GB': 'dd/MM/yyyy',
  sv: 'yyyy-MM-dd',
  nb: 'dd.MM.yyyy',
};

export const toDate = (dateTime: any) => {
  if (LocalDate.prototype.isPrototypeOf(dateTime)) {
    return dateTime;
  }
  if (typeof dateTime === 'string') {
    dateTime = new Date(dateTime);
  }
  return LocalDate.from(nativeJs(dateTime));
};

// @ts-expect-error ts-migrate(7024) FIXME: Function implicitly has return type 'any' because ... Remove this comment to see the full error message
export const isValidDate = (value: any) => {
  if (Object.prototype.toString.call(value) === '[object Date]') {
    // it is a date
    if (isNaN(value.getTime())) {
      // d.valueOf() could also work
      // date is not valid
      return false;
    } else {
      // date is valid
      return true;
    }
  } else {
    // not a date
    if (!value) return false;
    return isValidDate(new Date(value));
  }
};

export const addDays = (date: any, noOfDays: any) => {
  if (!isValidDate(date)) return null;
  const copiedDate = new Date(date);
  return new Date(copiedDate.setDate(copiedDate.getDate() + noOfDays));
};

export const isEqual = (d1: any, d2: any) =>
  toDate(new Date(d1)).equals(toDate(new Date(d2)));

// @ts-expect-error ts-migrate(7024) FIXME: Function implicitly has return type 'any' because ... Remove this comment to see the full error message
export const getNextWeekday = (date: any, noOfDays = 1) => {
  try {
    if (new Date(date).getDay() === 6) noOfDays++;
    const tomorrow = new Date(date.setDate(date.getDate() + noOfDays));
    return tomorrow.getDay() % 6 > 0
      ? tomorrow
      : getNextWeekday(tomorrow, noOfDays);
  } catch (error) {
    throw new Error(`Error in getNextWeekday: \n${error}`);
  }
};

export const isWeekend = (date: any) =>
  date.getDay() === 6 || date.getDay() === 0;
